<script lang="ts">
	import type { LegalLink } from './types';
	import { page } from '$app/state';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import * as m from '$paraglide/messages';
	import { legalLinksPerLocale } from './legalLinks';

	const COOKIE_PATH = 'COOKIE_PATH';

	const locale = $derived(page.data?.locale ?? 'en-US');

	const links: LegalLink[] = $derived([
		{
			path: legalLinksPerLocale[locale].legalNotice,
			label: m.legal_link__legal_notice(),
		},
		{
			path: legalLinksPerLocale[locale].termOfUse,
			label: m.legal_link__term_of_use(),
		},
		{
			path: COOKIE_PATH,
			label: m.legal_link__cookies(),
		},
		{
			path: legalLinksPerLocale[locale].credit,
			label: m.legal_link__credits(),
		},
		{
			path: legalLinksPerLocale[locale].confidentialityPolicy,
			label: m.legal_link__confidentiality_policy(),
		},
		{ path: legalLinksPerLocale[locale].contact, label: m.legal_link__contact() },
	]);

	const currentYear = new Date().getFullYear();
</script>

<ul
	class="bg-primary text-neutral-weakest rd-t-4 py-1 px-4 link-list m-0 p-0 flex gap-2 items-center text-sm justify-center flex-wrap"
>
	<!-- eslint-disable-next-line svelte/require-each-key -->
	{#each links as link}
		<li>
			{#if link.path === COOKIE_PATH}
				<Button
					text={link.label}
					variant="ghost"
					size="sm"
					class="m-0 p-0 border-none bg-transparent text-neutral-weakest"
					onclick={() => window.Didomi?.preferences.show()}
				/>
			{:else}
				<Link
					target="_blank"
					href={link.path}
					label={link.label}
					button="ghost"
					size="sm"
					class="p-0 text-neutral-weakest"
				/>
			{/if}
		</li>
	{/each}
	<li class="text-sm text-bold">
		<div class="flex items-center h-9">&copy; Michelin {currentYear}</div>
	</li>
</ul>

<style>
	.link-list {
		list-style: none;
		row-gap: 0px;
	}
</style>
